import type { FunctionComponentWithRef } from "react";
import { graphql, useFragment } from "react-relay";

import { BaseLinkContextProvider } from "shared/components/common/base-link/context";
import { tracking } from "shared/data";

import type { heroArticlesHomeV2Content$key } from "scmp-app/queries/__generated__/heroArticlesHomeV2Content.graphql";

import { StyledHeroArticle } from "./styles";

type Props = {
  className?: string;
  clickTrackingFunction: (entityId?: string) => void;
  reference: heroArticlesHomeV2Content$key;
};

export const HomeV2HeroArticles: FunctionComponentWithRef<Props, HTMLDivElement> = ({
  className,
  clickTrackingFunction,
  ref,
  reference,
}) => {
  const content = useFragment(
    graphql`
      fragment heroArticlesHomeV2Content on Content {
        ...topStoriesItemV2Content
      }
    `,
    reference,
  );

  if (!content) return null;

  return (
    <BaseLinkContextProvider
      customQueryParameters={{
        module: tracking.module.TopStory,
      }}
    >
      <StyledHeroArticle
        className={className}
        isShowImage
        onClick={clickTrackingFunction}
        ref={ref}
        reference={content}
        withCarousel
        withExclusiveHeaderFlag
        withSection={false}
        withSeriesShortLabel
        withSummary
      />
    </BaseLinkContextProvider>
  );
};

HomeV2HeroArticles.displayName = "HomeV2HeroArticles";
